// This file is automatically generated. Do not edit manually.

import { ControlChartParentGroup } from "src/api/generated/postgres/db/types/public_/tables/controlChartParentGroup";
import { ChartGroup } from "src/api/generated/postgres/db/types/public_/tables/chartGroup";
import { ControlChart } from "src/api/generated/postgres/db/types/public_/tables/controlChart";
import { Resource } from "src/api/generated/postgres/db/types/ext_resourcing/tables/resource";
import { Item } from "src/api/generated/postgres/db/types/ext_resourcing/tables/item";
import { makeAxiosRequest } from "src/api/utils/apiClient";
import { t } from "i18next";

export namespace ControlChartSelectionApi {
	export async function getControlChartParentGroups(): Promise<Array<ControlChartParentGroup>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getControlChartParentGroups",
			method: "POST",
			data: {},
		});
		return response as Array<ControlChartParentGroup>;
	}

	export async function getControlChartGroupsInParentGroup(args: {
		parentGroupId: number;
	}): Promise<Array<ChartGroup>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getControlChartGroups",
			method: "POST",
			data: {
				parentGroupId: args.parentGroupId,
			},
		});
		return response as Array<ChartGroup>;
	}

	export async function getControlChartsInChartGroup(args: {
		chartGroupId: number;
	}): Promise<Array<ControlChart>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getControlChartsInGroup",
			method: "POST",
			data: {
				chartGroupId: args.chartGroupId,
			},
		});
		return response as Array<ControlChart>;
	}

	export async function getResources(): Promise<Array<Resource>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getResources",
			method: "POST",
			data: {},
		});
		return response as Array<Resource>;
	}

	export async function getResourceItems(args: { resourceId: number }): Promise<Array<Item>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getResourceItems",
			method: "POST",
			data: {
				resourceId: args.resourceId,
			},
		});
		return response as Array<Item>;
	}

	export async function getControlChartsForResourceItem(args: {
		resourceItemId: number;
	}): Promise<Array<ControlChart>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getControlChartsForResourceItem",
			method: "POST",
			data: {
				resourceItemId: args.resourceItemId,
			},
		});
		return response as Array<ControlChart>;
	}

	export async function getSelectionValuesForControlChart(args: {
		controlChartId: number;
	}): Promise<ControlChartSelectionApi_Selection> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlCharts/selection/getSelectionValuesForControlChart",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
			},
		});
		return response as ControlChartSelectionApi_Selection;
	}
}

export interface ControlChartSelectionApi_Selection {
	chartGroupId: number | null | undefined;
	chartGroupOrResource: ControlChartSelectionApi_ControlChartGroupOrResource;
	chartParentGroupId: number | null | undefined;
	controlChartId: number | null | undefined;
	resourceId: number | null | undefined;
	resourceItemId: number | null | undefined;
}

export const ControlChartSelectionApi_ControlChartGroupOrResourceValues = [
	"CONTROL_CHART_GROUP",
	"RESOURCE",
] as const;

export type ControlChartSelectionApi_ControlChartGroupOrResource =
	(typeof ControlChartSelectionApi_ControlChartGroupOrResourceValues)[number];

export const getControlChartSelectionApi_ControlChartGroupOrResourceLabels = () => ({
	CONTROL_CHART_GROUP: t("control_chart_group"),
	RESOURCE: t("resource"),
});

export const getControlChartSelectionApi_ControlChartGroupOrResourceLabel = (
	value: ControlChartSelectionApi_ControlChartGroupOrResource,
): string => {
	return getControlChartSelectionApi_ControlChartGroupOrResourceLabels()[value];
};
